import React, { useState } from "react";
import { fontsName } from "../../assets/fonts/fontsName";
import { useLocation } from "@reach/router";
// import details1 from "../../assets/images/projects/projects-details1.jpg";
import { GraphQLClient, gql } from "graphql-request";
import { REQUEST_URL } from "../RequestUrl";
// import SidebarAbout from "./SidebarAbout";

const GET_POST_DETAILS = gql`
  query GetNewsById($_id: String!) {
    getNewsById(_id: $_id) {
      _id
      titel
      description
      link
      date
      school_name
      newsType
      newsStatus
      personId {
        _id
        person_id
        person_name
        person_surname
        person_password
        person_national_id
        YearofBirth
        person_phone_number
        person_fatherName
        motherPhoneNumber
        fatherPhoneNumber
        level
        class_name
        school_name
        person_role
        photoURL
      }
    }
  }
`;

const NewsDetails = (props) => {
  // const { state = {} } = location;
  const [imagePost, setImagePost] = useState("");
  const [titlePost, setTitlePost] = useState("");
  const [descriptionPost, setDescriptionPost] = useState("");
  const [typeMediaPost, setTypeMediaPost] = useState("");
  const [postId, setPostId] = useState("");
  const [postDetailsData, setPostDetailsData] = useState(null);

  const client = new GraphQLClient(REQUEST_URL);

  const isBrowser = typeof window !== "undefined";
  let location = useLocation();
  // const value = React.useContext(PostContext);
  // React.useEffect(() => {
  //   if (location.state == null) {
  //     typeof window !== undefined && window.history.back();
  //   } else {
  //     console.log("location.state:", location.state);
  //     setImagePost(location.state.linkPost);
  //     setTitlePost(location.state.titlePost);
  //     setDescriptionPost(location.state.descriptionPost);
  //     setTypeMediaPost(location.state.typePost);
  //   }
  // }, [location.state]);

  React.useEffect(() => {
    if (isBrowser) {
      // console.log("aaaaaa");
      const pageId = window.location.href.substr(-24);
      if (pageId.length) {
        var variables = {
          _id: pageId,
        };
        client.request(GET_POST_DETAILS, variables).then((data) => {
          setPostDetailsData(data.getNewsById);
        });
      }
    }
  }, []);

  // React.useEffect(() => {
  //   console.log("postId:", postId);
  //   if (postId !== "") {
  //     var variables = {
  //       _id: postId,
  //     };
  //     client.request(GET_POST_DETAILS, variables).then((data) => {
  //       console.log("post-details:", data.getNewsById.link[0]);
  //       setImagePost(data.getNewsById.link[0]);
  //       setTypeMediaPost(data.getNewsById.newsType);
  //       setPostDetailsData(data.getNewsById);
  //     });
  //   }
  // }, [postId]);

  // React.useEffect(() => {
  //   if (postDetailsData) console.log("postDetailsData:", postDetailsData);
  // }, [postDetailsData]);

  return (
    <section className="case-studies-details-area ptb-100">
      <div className="container">
        <div className="row" dir="rtl">
          <div className="col-lg-9 col-md-12">
            <div className="case-studies-details-image">
              {/* <img src={imagePost} alt="news-details" /> */}
              {postDetailsData && postDetailsData?.newsType == "withPhoto" && (
                <img src={postDetailsData?.link[0]} alt="news" />
              )}
              {postDetailsData && postDetailsData?.newsType == "withVideo" && (
                <video
                  className="video-blog"
                  style={{ height: "350px", width: "100%" }}
                  controls
                >
                  <source src={postDetailsData?.link[0]} type="video/mp4" />
                </video>
              )}
            </div>
            <div className="case-studies-details-desc" dir="rtl">
              {/* <span className="sub-title">Data Science</span> */}
              <h3
                style={{
                  fontFamily: fontsName.Vazir,
                  textAlign: "justify",
                }}
              >
                {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است */}
                {postDetailsData && postDetailsData.titel
                  ? postDetailsData.titel
                  : ""}
              </h3>
              <p
                style={{
                  fontFamily: fontsName.Vazir,
                  textAlign: "justify",
                }}
              >
                {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
                نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
                جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و
                زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. */}
                {postDetailsData && postDetailsData.description
                  ? postDetailsData.description
                  : ""}
              </p>

              {/* <p
                style={{
                  fontFamily: fontsName.Vazir,
                  textAlign: "justify",
                  marginTop: "20px",
                }}
              >
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
                نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
                جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و
                زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
              </p> */}
            </div>
          </div>

          {/* <div className="col-lg-4 col-md-12">
              <SidebarAbout />
            </div> */}
        </div>
      </div>
    </section>
  );
};

export default NewsDetails;
